import {
  Button,
  InputLabel,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  DialogActions,
  ButtonGroup,
  Box,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import { language } from "../../../../../language";
import FolderSystem from "../../../../FolderTree/FolderSystem";
import GenericModal from "../../../../modal-closebtn/index";

const StyledBox = styled(Box)(({ theme }) => ({
  height: "75vh",
}));

const StyledFormControl = styled(Box)(({ theme }) => ({
  padding: "1% 1%",
}));

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// TAB PROPERTIES
function TabProperties(props) {
  const {
    metadadosValue,
    handleChangeTitulo,
    onChangeMetadados,
    documentTypeListValue,
    handleDocumentTypeSelect,
    taskFields,
    documentType,
    titulo,
    isCopy,
    handleCheckIsCopy,
  } = props;

  //alterando a lista variaveis do formulário para o componente de autocomplete
  const taskFieldsOptions = taskFields
    ? taskFields.map((item) => ({
        label: item.id,
        value: item.id,
      }))
    : [];

  return (
    <StyledFormControl>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputLabel>{language.title}</InputLabel>
          <TextField
            fullWidth
            variant="outlined"
            value={titulo}
            onChange={handleChangeTitulo}
            label={language.title}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel>{language.documentType}</InputLabel>
          <FormControl fullWidth variant="outlined">
            <Select
              value={documentTypeListValue}
              onChange={handleDocumentTypeSelect}
              label={language.documentType}
            >
              {documentType &&
                documentType.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <InputLabel>{language.metadataList}</InputLabel>
          <Autocomplete
            multiple
            options={taskFieldsOptions}
            value={metadadosValue}
            onChange={onChangeMetadados}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={language.metadataList}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isCopy}
                onChange={handleCheckIsCopy}
                name="isCopy"
              />
            }
            label={language.isCopy}
          />
        </Grid>
      </Grid>
    </StyledFormControl>
  );
}

// TAB CONFIGURATION
function TabConfiguration(props) {
  const {
    parentFolderTemplateName,
    onChangeParentFolderTemplateName,
    selectedFolder,
    onSelectFolder,
  } = props;

  return (
    <StyledFormControl>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputLabel>{language.parentFolderTemplateName}</InputLabel>
          <TextField
            fullWidth
            variant="outlined"
            value={parentFolderTemplateName}
            onChange={onChangeParentFolderTemplateName}
            label={language.parentFolderTemplateName}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel>{language.selectFolder}</InputLabel>
          <FolderSystem
            onSelectFolder={onSelectFolder}
            selectedFolder={selectedFolder}
          />
        </Grid>
      </Grid>
    </StyledFormControl>
  );
}

// OVERRIDE MODAL ACTIONS
function OverrideModalActions(props) {
  const { handleSave, handleClose, isInvalid } = props;

  return (
    <DialogActions>
      <Button onClick={handleClose} color="primary">
        {language.cancel}
      </Button>
      <Button
        onClick={handleSave}
        color="primary"
        variant="contained"
        disabled={isInvalid}
      >
        {language.save}
      </Button>
    </DialogActions>
  );
}

const ModelerModalGerarPdfRegistrar = ({
  saveGerarPdfRegistrar,
  businessObject,
  element,
  extensionElements,
  selectBox,
  bpmnFactory,
  taskFields,
  documentType,
}) => {
  const [open, setOpen] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [metadadosValue, setMetadadosValue] = useState([]);
  const [documentTypeListValue, setDocumentTypeListValue] = useState("");
  const [parentFolderTemplateName, setParentFolderTemplateName] = useState("");
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [titulo, setTitulo] = useState("");
  const [isCopy, setIsCopy] = useState(false);

  useEffect(() => {
    // Initialize component state
    setOpen(true);
    setTabValue(0);
    setMetadadosValue([]);
    setDocumentTypeListValue("");
    setParentFolderTemplateName("");
    setSelectedFolder(null);
    setTitulo("");
    setIsCopy(false);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleClearState = () => {
    setMetadadosValue([]);
    setDocumentTypeListValue("");
    setParentFolderTemplateName("");
    setSelectedFolder(null);
    setTitulo("");
    setIsCopy(false);
  };

  const handleCheckIsCopy = (event) => {
    setIsCopy(event.target.checked);
  };

  const handleDocumentTypeSelect = (event) => {
    setDocumentTypeListValue(event.target.value);
  };

  const handleMetadataListChange = (event, newValue) => {
    setMetadadosValue(newValue);
  };

  const handleChangeTitulo = (event) => {
    setTitulo(event.target.value);
  };

  const handleSelectFolder = (event, nodeIds) => {
    setSelectedFolder(nodeIds);
  };

  const handleParentFolderTemplateName = (event, newValue) => {
    setParentFolderTemplateName(newValue);
  };

  const handleSave = () => {
    const gerarPdfRegistrarData = {
      metadados: metadadosValue,
      documentType: documentTypeListValue,
      parentFolderTemplateName,
      selectedFolder,
      titulo,
      isCopy,
    };

    saveGerarPdfRegistrar(
      businessObject,
      element,
      extensionElements,
      selectBox,
      bpmnFactory,
      gerarPdfRegistrarData,
    );

    handleClearState();
    setOpen(false);
  };

  const isInvalid = !titulo || !documentTypeListValue || !metadadosValue.length;

  return (
    <GenericModal
      title={language.generatePdfRegister}
      handleClose={handleClose}
      size="lg"
      bigHeight
      open={open}
      handleSubmit={handleSave}
      btnActionTitle={language.confirm}
      disabledAction={isInvalid}
    >
      <StyledBox>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleChangeTab}>
            <Tab label={language.properties} />
            <Tab label={language.configuration} />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <TabProperties
            metadadosValue={metadadosValue}
            handleChangeTitulo={handleChangeTitulo}
            onChangeMetadados={handleMetadataListChange}
            documentTypeListValue={documentTypeListValue}
            handleDocumentTypeSelect={handleDocumentTypeSelect}
            taskFields={taskFields}
            documentType={documentType}
            titulo={titulo}
            isCopy={isCopy}
            handleCheckIsCopy={handleCheckIsCopy}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <TabConfiguration
            parentFolderTemplateName={parentFolderTemplateName}
            onChangeParentFolderTemplateName={handleParentFolderTemplateName}
            selectedFolder={selectedFolder}
            onSelectFolder={handleSelectFolder}
          />
        </TabPanel>
      </StyledBox>
    </GenericModal>
  );
};

ModelerModalGerarPdfRegistrar.propTypes = {
  saveGerarPdfRegistrar: PropTypes.func,
  businessObject: PropTypes.object,
  element: PropTypes.object,
  extensionElements: PropTypes.object,
  selectBox: PropTypes.object,
  bpmnFactory: PropTypes.object,
  taskFields: PropTypes.array,
  documentType: PropTypes.array,
};

export default ModelerModalGerarPdfRegistrar;
